export const useAuthStore = defineStore('authStore', {
  state: () => ({
    _userInfo: null as IArtistInfoSelect.ResponseItem | null,
  }),
  getters: {
    isLogin: () => {
      return !!useServiceCookie(COOKIE_NAME.ACCESS_TOKEN).get()
    },
    accessToken: () => {
      return useServiceCookie(COOKIE_NAME.ACCESS_TOKEN).get()
    },
    userInfo: (state) => state._userInfo,
  },
  actions: {
    setTokens(tokens: ILoginInsert.ResponseItem) {
      useServiceCookie(COOKIE_NAME.ACCESS_TOKEN, {
        expires: new Date(tokens.expiredAt),
      }).set(tokens.accessToken)
    },

    removeTokens() {
      useServiceCookie(COOKIE_NAME.ACCESS_TOKEN).remove()
    },

    async login(id: string, password: string) {
      const $nuxt = useNuxtApp()
      const response = await $nuxt.$apiService.authApi.login(id, password)
      this.setTokens(response)
      return response
    },
    async logout() {
      try {
        const $nuxt = useNuxtApp()
        await $nuxt.$apiService.authApi.logout()
      } catch (_error) {
        // 별도의 처리 로직 없음
      } finally {
        this.removeTokens()
        this._userInfo = null
      }
    },
    async getUserInfo() {
      const $nuxt = useNuxtApp()
      const response = await $nuxt.$apiService.artistApi.selectArtistInfo()
      this._userInfo = response
    },
  },
})
